/* ===========================================================================
   Atelier behaviour
   ---------------------------------------------------------------------------
   1. GSAP entrances (hero, rows of four, image reveals, banner parallax).
      Runs only when GSAP loaded, motion is allowed and we are not inside the
      theme editor. Otherwise the CSS reveal from clara.css stays in charge.
   2. Product page: gallery thumbs and the size picker.
   3. Collection page: filters and sort submit on change.
   ========================================================================= */

(function () {
  "use strict";

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var root = document.documentElement;
  var body = document.body;
  var editor = body.classList.contains("clara-editor") || (window.Shopify && window.Shopify.designMode);

  /* ------------------------------------------------ header bits -------- */

  $$("#mega-r > .mi > a, #mega-r > .mi--flat").forEach(function (a) {
    if ($(".nav-shift", a)) return;
    var label = a.textContent.trim();
    a.textContent = "";
    var shell = document.createElement("span");
    shell.className = "nav-shift";
    var one = document.createElement("span");
    var two = document.createElement("span");
    one.textContent = label;
    two.textContent = label;
    two.setAttribute("aria-hidden", "true");
    shell.appendChild(one);
    shell.appendChild(two);
    a.appendChild(shell);
  });

  function watchCount() {
    var n = $("#cart-n");
    if (!n || !n.classList.contains("hdr__count")) return;
    var sync = function () { n.classList.toggle("is-zero", n.textContent.trim() === "0"); };
    sync();
    new MutationObserver(sync).observe(n, { childList: true, characterData: true, subtree: true });
  }
  watchCount();

  /* ------------------------------------------------------- motion ------ */

  function motion() {
    var gsap = window.gsap;
    var ST = window.ScrollTrigger;
    if (!body.classList.contains("has-motion") || editor || !gsap || !ST) {
      body.classList.add("no-gsap");
      return;
    }
    gsap.registerPlugin(ST);
    root.classList.add("gs");

    var mm = gsap.matchMedia();
    mm.add({ ok: "(prefers-reduced-motion: no-preference)", reduce: "(prefers-reduced-motion: reduce)" }, function (ctx) {
      if (ctx.conditions.reduce) {
        gsap.set(".hero--anim-fade .hero__copy > *, [data-hero-fade]", { autoAlpha: 1 });
        return;
      }

      /* hero: copy rises line by line, the frame settles from a slight zoom */
      $$(".hero--anim-fade").forEach(function (hero) {
        var tl = gsap.timeline({ defaults: { ease: "power3.out" } });
        var media = $(".hero__media video.hero__video--desktop", hero);
        if (media) tl.fromTo(media, { scale: 1.08 }, { scale: 1, duration: 2.2, ease: "power2.out" }, 0);
        tl.fromTo($$(".hero__copy > *", hero), { autoAlpha: 0, y: 36 }, { autoAlpha: 1, y: 0, duration: 1.1, stagger: 0.14 }, 0.2);

        gsap.to($(".hero__copy", hero), {
          yPercent: -14, ease: "none",
          scrollTrigger: { trigger: hero, start: "top top", end: "bottom top", scrub: true }
        });
      });

      gsap.fromTo("[data-hero-fade]", { autoAlpha: 0, y: 30 }, { autoAlpha: 1, y: 0, duration: 1.1, ease: "power3.out", delay: 0.15 });

      /* rows: anything carrying .rise enters in batches, four across */
      gsap.set(".rise", { autoAlpha: 0, y: 40 });
      ST.batch(".rise", {
        start: "top 90%",
        once: true,
        onEnter: function (batch) {
          gsap.to(batch, { autoAlpha: 1, y: 0, duration: 0.9, ease: "power3.out", stagger: 0.1, overwrite: true });
        }
      });

      /* images that open from their own frame (clara-anim.js does it tied to
         the scroll instead when «Imagen que se abre al bajar» is on) */
      if (!body.classList.contains("anim-open")) $$("[data-reveal-img]").forEach(function (box) {
        var img = $("img", box);
        var tl = gsap.timeline({ scrollTrigger: { trigger: box, start: "top 82%", once: true } });
        tl.fromTo(box, { clipPath: "inset(10% 10% 10% 10%)" }, { clipPath: "inset(0% 0% 0% 0%)", duration: 1.4, ease: "expo.out" }, 0);
        if (img) tl.fromTo(img, { scale: 1.22 }, { scale: 1, duration: 1.8, ease: "expo.out" }, 0);
      });

      /* collection banner drifts slower than the page */
      $$("[data-parallax]").forEach(function (box) {
        var img = $$("img", box);
        if (!img.length) return;
        gsap.fromTo(img, { yPercent: -6 }, {
          yPercent: 6, ease: "none",
          scrollTrigger: { trigger: box.parentNode, start: "top top", end: "bottom top", scrub: true }
        });
      });

      return function () { gsap.set(".rise", { clearProps: "all" }); };
    });

    window.addEventListener("load", function () { ST.refresh(); });
  }

  /* ------------------------------------------------- product page ------ */

  function moneyFmt(cents) {
    var f = window.claraMoneyFormat || "{{amount_with_comma_separator}} €";
    var n = (cents / 100);
    var dot = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    var comma = n.toFixed(2).replace(".", ",").replace(/\B(?=(\d{3})+(?!\d),)/g, ".");
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === "amount_with_comma_separator") return comma;
      if (k === "amount_no_decimals") return Math.round(n).toString();
      if (k === "amount_no_decimals_with_comma_separator") return Math.round(n).toString();
      return dot;
    });
  }

  function initGallery(scope) {
    $$("[data-gallery]", scope).forEach(function (g) {
      if (g.dataset.ready) return;
      g.dataset.ready = "1";
      var stage = $("[data-stage]", g);
      var slides = $$("[data-slide]", g);
      var thumbs = $$("[data-thumb]", g);
      var dots = $$(".pdp__dots i", g);
      if (!stage || slides.length < 2) return;

      function mark(i) {
        thumbs.forEach(function (t, k) { t.classList.toggle("is-on", k === i); });
        dots.forEach(function (d, k) { d.classList.toggle("on", k === i); });
        var t = thumbs[i];
        if (t && t.parentNode.scrollHeight > t.parentNode.clientHeight) t.scrollIntoView({ block: "nearest" });
      }
      function go(i) { stage.scrollTo({ left: slides[i].offsetLeft - stage.offsetLeft, behavior: "smooth" }); mark(i); }

      thumbs.forEach(function (t, i) { t.addEventListener("click", function () { go(i); }); });

      var timer;
      stage.addEventListener("scroll", function () {
        clearTimeout(timer);
        timer = setTimeout(function () { mark(Math.round(stage.scrollLeft / stage.clientWidth)); }, 60);
      }, { passive: true });

      stage.addEventListener("keydown", function (e) {
        var cur = Math.round(stage.scrollLeft / stage.clientWidth);
        if (e.key === "ArrowRight") { e.preventDefault(); go(Math.min(cur + 1, slides.length - 1)); }
        if (e.key === "ArrowLeft")  { e.preventDefault(); go(Math.max(cur - 1, 0)); }
      });

      g.goToMedia = function (id) {
        var idx = slides.findIndex(function (s) { return s.dataset.mediaId === String(id); });
        if (idx > -1) go(idx);
      };
    });
  }

  function initPicker(scope) {
    $$("[data-pdp]", scope).forEach(function (pdp) {
      var form = $(".pdp__form", pdp);
      if (!form || form.dataset.ready) return;
      form.dataset.ready = "1";
      var json = $("[data-variants]", form);
      if (!json) return;
      var variants = JSON.parse(json.textContent);
      var idInput = $("[data-variant-id]", form);
      var btn = $(".pdp__add", form);
      var price = $("[data-price]", pdp);
      var gallery = $("[data-gallery]", pdp);
      var S = window.claraStrings || {};
      var labelAdd = btn ? (btn.dataset.labelAdd || btn.textContent.trim()) : "";
      var saveTpl = price ? price.getAttribute("data-save") : null;

      function selected() {
        return $$("fieldset.pdp__opt", form).map(function (fs) {
          var c = $("input:checked", fs);
          return c ? c.value : null;
        });
      }

      function refreshAvailability(sel) {
        $$("fieldset.pdp__opt", form).forEach(function (fs, oi) {
          $$("input", fs).forEach(function (inp) {
            var probe = sel.slice();
            probe[oi] = inp.value;
            var hit = variants.some(function (v) {
              return v.available && v.options.every(function (o, k) { return probe[k] === null || o === probe[k]; });
            });
            inp.parentNode.classList.toggle("is-out", !hit);
          });
        });
      }

      function update() {
        var sel = selected();
        var v = variants.find(function (x) { return x.options.every(function (o, k) { return o === sel[k]; }); });
        refreshAvailability(sel);
        if (!v || !btn) return;
        idInput.value = v.id;
        btn.setAttribute("data-add", v.id);
        btn.disabled = !v.available;
        btn.textContent = v.available ? labelAdd : (btn.dataset.labelSold || S.soldOut || labelAdd);
        if (price) {
          var html = "";
          if (v.compare > v.price) {
            html += "<s class=\"card__was\">" + moneyFmt(v.compare) + "</s>";
            html += "<span class=\"card__now\">" + moneyFmt(v.price) + "</span>";
            if (saveTpl) {
              var pct = Math.floor((v.compare - v.price) * 100 / v.compare);
              html += "<span class=\"card__save\">" + saveTpl.replace("%p", pct) + "</span>";
            }
          } else {
            html += "<span class=\"card__now\">" + moneyFmt(v.price) + "</span>";
          }
          price.innerHTML = html;
        }
        if (v.media && gallery && gallery.goToMedia) gallery.goToMedia(v.media);
        if (history.replaceState) {
          var u = new URL(location.href);
          u.searchParams.set("variant", v.id);
          history.replaceState(null, "", u.toString());
        }
      }

      form.addEventListener("change", function (e) { if (e.target.matches("[data-opt]")) update(); });
      refreshAvailability(selected());
    });
  }

  /* --------------------------------------------- collection filters ---- */

  function initFilters(scope) {
    $$("[data-filters]", scope).forEach(function (form) {
      if (form.dataset.ready) return;
      form.dataset.ready = "1";
      var submit = function () {
        $$("input[type=number]", form).forEach(function (i) { if (i.value === "") i.disabled = true; });
        form.submit();
      };
      form.addEventListener("change", function (e) {
        if (e.target.matches("input[type=checkbox], select, input[type=number]")) submit();
      });
    });
  }

  /* ------------------------------------------------------ hero video ---- */

  function visibleVideos(hero) {
    return $$(".hero__video", hero).filter(function (v) { return v.offsetParent !== null; });
  }

  function initHeroVideo(scope) {
    $$(".hero", scope).forEach(function (hero) {
      var btn = $("[data-hero-pause]", hero);
      $$(".hero__video", hero).forEach(function (v) {
        v.muted = true;
        v.playsInline = true;
        if (v.offsetParent !== null) {
          var pl = v.play();
          if (pl && pl.catch) pl.catch(function () {});
        }
      });
      if (!btn || btn.dataset.ready) return;
      btn.dataset.ready = "1";
      btn.addEventListener("click", function () {
        var paused = btn.getAttribute("aria-pressed") !== "true";
        visibleVideos(hero).forEach(function (v) {
          if (paused) v.pause();
          else { var pl = v.play(); if (pl && pl.catch) pl.catch(function () {}); }
        });
        btn.setAttribute("aria-pressed", String(paused));
        btn.setAttribute("aria-label", paused ? btn.dataset.labelPlay : btn.dataset.labelPause);
      });
    });
  }

  function initAll(scope) {
    initHeroVideo(scope);
    initGallery(scope);
    initPicker(scope);
    initFilters(scope);
  }

  initAll(document);

  motion();

  document.addEventListener("shopify:section:load", function (e) {
    initAll(e.target);
    watchCount();
  });
})();
